import { AccountType, UserPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { AlertMessage, BaseModal } from 'components/molecules';
import { UserForm } from 'components/organisms/forms';
import React, { useState } from 'react';
import { useUser } from 'utils/hooks';

import { ModalProps } from './types';

export const AddUser = ({ open, onClose }: ModalProps) => {
  const { createUser, iniCreateUser } = useUser();
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onSubmit = async (submitUser: UserPayload) => {
    const { userRole, ...data } = submitUser;
    try {
      const resultData = await createUser(userRole as AccountType, data);
      if (resultData && resultData.id) {
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          onClose();
        }, 1500);
      }
    } catch (error: any) {
      if (error.response && error.response.status === 403) {
        setErrorMessage(
          'Unexpected error occured. Please refresh the page and try again.',
        );
      } else if (error.message) {
        setErrorMessage(`ERROR: ${error.message}`);
      } else {
        setErrorMessage('Unexpected error. Please Try again.');
      }
    }
  };

  return (
    <BaseModal open={open} onClose={onClose} title={'Add User'}>
      <UserForm
        disableAll={showSuccess}
        initValue={iniCreateUser}
        onBack={onClose}
        onSubmit={onSubmit}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'User successfully updated'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </BaseModal>
  );
};
